// --------------------------------------------------------------------------
// #TBC – National Results
//     - handles rendering of national results donut chart
//     - this heavily based on the bar chart results but adapted
// --------------------------------------------------------------------------
// Author:      Sarah Blount & Richard Bultitude & Alix Richards
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     2
// --------------------------------------------------------------------------

'use strict';

var $ = window.$ = window.jQuery = require('jquery');
var debounce = require('../../utilities/debounce');

// Chart plugin
// require('../plugins/highcharts.js');
var Highcharts = require('highcharts-release');

module.exports = function (options) {
    var context = options.context;
    var $chartContainer = context.find('.highcharts-container');
    var $chartMasterContainer = context.parents('.infographic__chart-wrapper');
    var birdNames = [];
    var birdValues = [];
    var chart;
    var chartType = 'pie';
    var chartMidMQ = window.matchMedia('(max-width: 1024px)');
    var chartSmallMQ = window.matchMedia('(max-width: 650px)');
    var firstLoad = true;

    Highcharts.setOptions({
        lang: {
            thousandsSep: ','
        }
    });

    function pollAndDisplay() {
        var chartToLoad;
        chartToLoad = window.setInterval(function () {
            if ($('.highcharts-container > svg').length > 0) {
                chart.reflow();
                // Permanently stop polling
                window.clearInterval(chartToLoad);
            }
        }, 100);
    }
    /**
     * [runChart description]
     * @param  {number} startAngle Angle in degrees
     * @param  {number} endAngle   Angle in degrees
     * @param  {string} hPos       Chart horizontal postion as a percentage
     * @param  {string} vPos       Chart vertical position as a percentage
     * @param  {string} size       Chart size as a percentage
     * @param  {boolean} firstLoad  Whether it's the 1st time the module has run
     * @return {boolean}            default value
     */
    function runChart(startAngle, endAngle, hPos, vPos, size, firstLoad) {
        chart = new Highcharts.Chart({
            chart: {
                backgroundColor: 'transparent',
                type: chartType,
                style: {
                    fontFamily: 'urbanolight'
                },
                renderTo: context[0]
            },
            title: {
                text: null
            },
            tooltip: {
                // pointFormat: '{series.name}: <b>{point.percentage:.0f}</b>',
                formatter: function formatter() {
                    var sliceIndex = this.point.index;
                    var slicePercentage = Math.round(this.point.percentage);
                    var sliceName = this.series.chart.axes[0].categories[sliceIndex];
                    return 'The value for <b>' + sliceName + '</b> is <b>' + this.y + ' or ' + slicePercentage + '%</b>';
                }
            },
            plotOptions: {
                pie: {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    center: [hPos, vPos],
                    showInLegend: false,
                    borderColor: '#FFFFFF',
                    borderWidth: 2,
                    size: size
                },
                series: {
                    dataLabels: {
                        enabled: true,
                        style: { 'color': '#FFFFFF', textShadow: false, fontFamily: 'urbanolight', fontSize: '12px' },
                        distance: 50,
                        shadow: false,
                        crop: false,
                        connectorColor: '#FFFFFF',
                        connectorWidth: 1,
                        formatter: function formatter() {
                            var sliceIndex = this.point.index;
                            var sliceName = this.series.chart.axes[0].categories[sliceIndex];
                            return sliceName;
                        }
                    }
                }
            },
            xAxis: {
                type: 'category',
                categories: birdNames
            },
            colors: ['#cdd4e9', '#e1f0fc', '#9cadd2', '#c1e0f7', '#6989bc', '#9dcff2', '#3169a5', '#71bfec', '#004f91', '#2dafe6'],
            series: [{
                type: 'pie',
                name: 'birdNames',
                innerSize: '40%',
                data: birdValues
            }],
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            }
        });
        /**
         * Once chart has been created 1st time
         * Handle bug whereby incorrect SVG width is set
         * and set DOM vars
         */
        if (firstLoad) {
            pollAndDisplay();
        }
    }

    function setChartLayout() {
        var newHeight;
        var startAngle;
        var endAngle;
        var hPos;
        var vPos;
        var size;
        if (chartSmallMQ.matches) {
            newHeight = 360;
            startAngle = 0;
            endAngle = 180;
            hPos = '0%';
            vPos = '50%';
            size = '90%';
            $chartContainer.css({ 'position': 'absolute' });
            $chartMasterContainer.css({ 'height': 'auto' });
        } else if (chartMidMQ.matches) {
            newHeight = 340;
            startAngle = -90;
            endAngle = 90;
            hPos = '50%';
            vPos = '80%';
            size = '100%';
            $chartContainer.css({ 'position': 'absolute' });
            $chartMasterContainer.css({ 'height': 'auto' });
        } else {
            newHeight = 650;
            startAngle = 0;
            endAngle = 180;
            hPos = '5%';
            vPos = '45%';
            size = '100%';
            $chartContainer.css({ 'position': 'static' });
            $chartMasterContainer.css({ 'height': 'auto' });
        }
        context.css({ height: newHeight });
        if (chart !== undefined) {
            chart.destroy();
            firstLoad = false;
        }
        runChart(startAngle, endAngle, hPos, vPos, size, firstLoad);
    }

    function init() {

        var data = context.find('[data-binding="data"] tr').children();
        var birdCount = data.length;
        var i;

        birdNames.length = 0;
        birdValues.length = 0;

        // Loop through data and create arrays of x and y values
        for (i = 0; i < birdCount; i++) {
            if ($(data[i]).attr('data-binding') === 'name') {
                birdNames.push(data[i].innerHTML);
            } else if ($(data[i]).attr('data-binding') === 'value') {
                birdValues.push(parseInt(data[i].innerHTML));
            }
        }

        // Intialise chart
        setChartLayout();

        // Run resize event to reintialise chart if change in screen size
        $(window).on('resize', debounce(function () {
            setChartLayout();
        }, 1250));

        //Run resize event if chart is inside a hidden tab
        $(context).on('tab.hasChanged', function () {
            setChartLayout();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/bgbw/nationwide-results.js
// module id = 222
// module chunks = 0